module.exports = __webpack_public_path__ + "static/media/logo.0789dc61.png";